<template>
  <ui-modal
    class="ui-modal-alert"
    :is-open.sync="innerIsOpen"
    :cancel-button-title="getTitleCloseButton"
    :has-success-button="false"
    :can-hide-parent="false"
    :has-header="false"
    is-footer-center
    size="s"
    @close="closeModal"
  >
    <div class="ui-modal-alert-body">
      <div class="ui-modal-alert-title">
        {{title}}
      </div>
      <div v-if="hasMessages" class="ui-modal-alert-message-list">
        <div
          v-for="(message, index) in messages"
          :key="index"
          class="ui-modal-alert-message-list__item"
        >
          {{message}}
        </div>
      </div>
    </div>
  </ui-modal>
</template>

<script>
import { UiModal } from '../../components'

import modalMixin from '../../mixins/modalMixin'

export default {
  name: 'UiModalAlert',
  components: {
    UiModal
  },
  mixins: [modalMixin],
  props: {
    config: {
      type: Object,
      default: () => ({
        isOpen: false
      })
    }
  },

  computed: {
    getTitleCloseButton () {
      return this.config.titleCloseButton || 'Закрыть'
    },
    title () {
      return this.config.title
    },
    messages () {
      return this.config.messages
    },
    hasMessages () {
      return Boolean(this.messages?.length)
    }
  },

  methods: {
    closeModal () {
      this.config.closeEvent?.()
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-modal-alert {
  z-index: 999999999;

  &-body {
    @include flex-column-center;
    padding: 0 30px;
  }

  &-title {
    @include font-title-22;
    text-align: center;
  }

  &-message-list {
    @include font-18;
    display: grid;
    grid-gap: 3px;
    width: 100%;
    margin-top: 12px;

    &__item {
      text-align: center;
    }
  }

  @include media-max-md {
    &-title {
      @include font-18;
    }

    &-message-list {
      @include font-16;
    }
  }
}
</style>
